import { axiosCall, axiosInstance } from "./axiosConfig";
import { axiosMethods, endPoints, QueryFilter } from "../Models/api";
export const accountSwitch = (accountId: number, signal?: AbortSignal) => {
  return axiosCall(axiosInstance, {
    url: endPoints.customerSupportManagement + "/support-users/accountswitch/" + accountId,
    method: axiosMethods.post,
    signal,
  });
};

export const getAccountAssigned = () => {
  return axiosCall(axiosInstance, {
    url: endPoints.customerSupportManagement + "/support-users/actingaccountid",
    method: axiosMethods.get,
  });
};

export const getAccounts = (filter: QueryFilter) => {
  return axiosCall(axiosInstance, {
    url: endPoints.customerSupportManagement + "/account",
    method: axiosMethods.get,
    params: filter,
  });
};

export const sendResetPasswordAPI = (email: string) => {
  return axiosCall(axiosInstance, {
    url: endPoints.securableManagement + "/password",
    method: axiosMethods.post,
    params: {
      email: email,
    },
  });
};

export const confirmResetPasswordAPI = (code: string, newPassword: string) => {
  return axiosCall(axiosInstance, {
    url: endPoints.userManagement + "/user/password-reset",
    method: axiosMethods.post,
    data: {
      oobCode: code,
      newPassword: newPassword,
    },
  });
};
